.activity-modal-footer {
    min-height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    border-top: 1px solid var(--off-white-dk);
    gap: 8px;
}

.footer-right-container {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: fit-content;
    justify-content: flex-end;
}

.sync-checkbox {
    min-width: 190px;
}
